<template>
    <div>
        <drop-down-button
            v-if="user && type === 'user'"
            @mouseover="showParentQuickViewProfile()"
            id="quickProfileView"
            :options="{}"
            :text="text"
            :no-arrow="false"
            dropdown-cls="simplified dropdown-menu-start"
            cls="ps-0"
            drop-class="user-quick-view">
            <template #content>
                <div class="header">
                    <avatar-image :src="user.image?.sizes?.sm ?? '/img/avatar.png'" :width="50" :height="50" />
                    <div>
                        <h5 class="mb-0">{{ user.name }} {{ user.surname }}</h5>
                        <p class="mb-0 text-gray-700">{{ user.roles[0]?.name }}</p>
                    </div>
                </div>
                <div class="items">
                    <div class="item small" v-if="user.email" @click="copyToClipboard(user.email)">
                        <span>{{ user.email }}</span>
                        <i class="fi fi-rr-copy-alt"></i>
                    </div>
                    <div class="item small" v-if="user.phone" @click="copyToClipboard(user.phone)">
                        <span>{{ user.phone }}</span>
                        <i class="fi fi-rr-copy-alt"></i>
                    </div>
                </div>
                <div class="footer d-flex align-items-center justify-content-between">
                    <basic-button
                        cls="btn-secondary btn-sm"
                        :text="trans('general.user.view_full_profile')"
                        :href="`/user/read/${user.id}`"
                        target="_blank"/>

                    <div class="d-flex align-items-center gap-2">
                        <basic-button
                            cls="px-2"
                            v-if="user.phone"
                            icon="fi-rr-phone-flip"
                            @click="callUser"/>
                        <basic-button
                            cls="px-2"
                            v-if="user.email"
                            icon="fi-rr-envelope-plus"
                            @click="sendEmail"/>
                    </div>
                </div>
            </template>
        </drop-down-button>
        <span v-if="type === 'invite'">{{ userId }}</span>
    </div>
</template>

<script>
import DropDownButton from "../../../theme/atoms/DropDownButton.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "UserQuickView",
    components: {DropDownButton, BasicButton},
    props: {
        userId: {
            type: Number|String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            user: null,
            type: 'user',
        }
    },
    watch: {
        userId: {
            immediate: true,
            handler() {
                this.type = typeof this.userId === 'number' ? 'user' : 'invite';
                this.getUserData();
            }
        }
    },
    methods: {
        showParentQuickViewProfile() {
            const button = document.getElementById('drop-btn-quickProfileView');
            if (button) {
                button.click();
            }
        },
        getUserData() {
            let params = {
                include: 'image;roles'
            };

            axios.get(`/user/read/${this.userId}`, {params})
                .then(response => {
                    this.user = response.data.data;
                })
        },
        sendEmail() {
            window.location.href = `mailto:${this.user.email}`;
        },
        callUser() {
            window.location.href = `tel:${this.user.phone}`;
        },
        copyToClipboard(value) {
            navigator.clipboard.writeText(value).then(() => {
                this.$notify({
                    type: 'success',
                    text: trans('general.defaults.copied_to_clipboard') + `: ${value}`,
                });
            }).catch(err => {
                this.$notify({
                    type: 'success',
                    text: trans('general.defaults.copy_failed') + `: ${err}`,
                });
            });
        },
    },
}
</script>
